import React, { useEffect, useRef, useState } from "react";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "../../assets/DataView/DataViewDemo.css";
import "../../assets/DataView/index.css";
import { InputText } from "primereact/inputtext";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "jspdf-autotable";
import jsPDF from "jspdf";
import logoBig from "../../assets/logo1.png";
import { FilterMatchMode } from 'primereact/api';
import { errorMessage, successMessage } from "../../utils/alertMessage";
import { formatDate, formatDateWithTime } from "../../constants/FormateDate";
import { Dialog } from "primereact/dialog";
import { DeleteLeadData, getLead, getLeadSource, getLeadStatusApi, getLeadType, getMasterLeadStatus, getUserLead, userLeadAssign } from "../../services/leads";
import { LeadListUpload } from "../../services/bankListUpload";
import { Dropdown } from "primereact/dropdown";
import { getUserData } from "../../utils/localStorage";
import { replaceUnderscoresWithSpaces, replaceUnderscoresWithSpacesAndUpperCase } from "../../components/Regex";
import { getBranch, getProduct, getStateWiseCities, getUser } from "../../services/userMasterUser";
import { Calendar } from "primereact/calendar";
import { MultiSelect } from "primereact/multiselect";
import { DataScroller } from 'primereact/datascroller';
import { Button } from "primereact/button";

export default function LeadList() {

  const [products, setProducts] = useState(null);
  const [filteredProducts, setFilteredProducts] = useState(null);
  const [selectedProducts, setSelectedProducts] = useState(null);

  const navigate = useNavigate();

  const { userProfileData } = getUserData();

  const location = useLocation();

  const ds = useRef(null);

  const isFirstRender = useRef(true);

  const [stateCitiesList, setStateCitiesList] = useState([])
  const [stateCityList, setStateCityList] = useState({});

  const [totalRecords, setTotalRecords] = useState(0);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(20);
  const [loadingMore, setLoadingMore] = useState(false);

  const [fileName, setFileName] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const [displayLeadListUpload, setDisplayLeadListUpload] = useState(false);

  const [displayLeadAssignmentUpload, setDisplayLeadAssignmentUpload] = useState(false);
  const [assignedTelecallerId, setAssignedTelecallerId] = useState("")
  const [assignedLeadId, setAssignedLeadId] = useState("")
  const [leadSourceUploadValue, setLeadSourceUploadValue] = useState("");

  const onClickLeadListUpload = (item) => {
    setDisplayLeadListUpload(true);
  };
  const onHideLeadListUpload = () => {
    setFileName("");
    setSelectedImage(null);
    setDisplayLeadListUpload(false);
  };

  const onClickLeadAssignmentUpload = (item) => {
    setAssignedLeadId(item)
    setDisplayLeadAssignmentUpload(true);
  };
  const onHideLeadAssignmentUpload = () => {

    setAssignedTelecallerId("");
    setDisplayLeadAssignmentUpload(false);
  };


  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    id: { value: null, matchMode: FilterMatchMode.CONTAINS },
    name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    mobile: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    quires: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    address: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
  });

  const [startDateValue, setStartDateValue] = useState(null);
  const [endDateValue, setEndDateValue] = useState(null);

  const [globalFilterValue, setGlobalFilterValue] = useState('');

  const [leadStatusList, setLeadStatusList] = useState([])
  const [leadSourceList, setLeadSourceList] = useState([])

  const [leadStatusValue, setLeadStatusValue] = useState("")
  const [leadSourceValue, setLeadSourceValue] = useState("")

  // const [branchDataList, setBranchDataList] = useState([])
  const [productDataList, setProductDataList] = useState([])
  // const [branchDataValue, setBranchDataValue] = useState("")
  const [productDataValue, setProductDataValue] = useState("")
  const [userDataFilter, setUserDataFilter] = useState("");

  const [stateValue, setStateValue] = useState('')
  const [cityValue, setCityValue] = useState('')

  const citiesList = stateCityList[stateValue] || [];

  const searchByStatusData = [
    { label: "Name", value: "name" },
    { label: "Mobile", value: "mobile" },
    { label: "Quires", value: "quires" },
    { label: "Address", value: "address" },
  ]

  const recordTypeSelection = [
    { label: "CreatedOn", value: "CreatedOn" },
    { label: "LeadOn", value: "LeadOn" },
    { label: "FollowUpOn", value: "FollowUpOn" },
    { label: "ClosedOn", value: "ClosedOn" }]

  const [recordTypeValue, setRecordTypeValue] = useState("CreatedOn")
  const [leadTypeList, setLeadTypeList] = useState([])
  const [typeOfLead, setTypeOfLead] = useState('')

  const [searchByStatus, setSearchByStatus] = useState('name');
  const [selectedTelecallerId, setSelectedTelecallerId] = useState("");
  const [userDataIds, setUserDataIds] = useState([]);
  const [allUserDataIds, setAllUserDataIds] = useState([]);

  const typeData = {
    searchBy: "",
    searchText: "",
    limit: 20,
    offset: 0,
    sortBy: "",
    sortOrder: "desc",
    statusIn: [],
    sourceIn: [],

    recordType: recordTypeValue,
    startDate: "",
    endDate: "",
    leadTypeIn: [],
    userIdIn: []
  };

  const fetchData = (data, append = false) => {
    setLoadingMore(true);

    getLead(data)
      // getUserLead(data)
      .then((response) => {
        if (!response.data.error) {

          const rawData = response.data.data || response.data;

          // 🔥 Extract only the lead object
          // const newData = rawData.map(item => item.lead);

          if (append) {
            setProducts((prev) => [...(prev || []), ...rawData]);
          } else {
            setProducts(rawData);
          }

          setTotalRecords(response.data.totalRecords || rawData.length);
        } else {
          errorMessage("Invalid Credentials");
        }
      })
      .catch(() => {
        errorMessage();
      })
      .finally(() => {
        setLoadingMore(false);
      });
  };

  const userData = {
    searchBy: "",
    searchText: "",
    limit: 1000,
    offset: 0,
    sortBy: "",
    sortOrder: "desc",
    userTypeIdIn: [],
    roleIn: ["ROLE_TELECALLER", "ROLE_OPERATION"],
    statusIn: []

  };

  const getUsers = (userData) => {
    getUser(userData)
      .then((response) => {
        if (!response.data.error) {
          const newData = response.data.data || response.data; // adjust if API structure differs
          const newDataId = newData.map(item => item.id);
          const newDataIds = newData.map(item => ({
            label: item.userName + " - " + item?.userTypeInfo, value: item.id
          }));

          setUserDataIds(newDataIds)
        }
      })
      .catch(() => {
        errorMessage();
      })
      .finally(() => {
        setLoadingMore(false);
      });
  }

  useEffect(() => {

    getLeadType()
      .then((response) => {
        if (!response.data.error) {
          const leadStatus = response.data.map((item) => ({
            label: item,
            value: item,
          }));
          setLeadTypeList(leadStatus);
        }
      })
      .catch(() => errorMessage());

    getUsers(userData)

    if (location.state?.listState) {
      const { products, first, rows } = location.state.listState;

      setProducts(products);
      setFirst(first);
      setRows(rows);
    } else {
      fetchData({
        ...typeData,
        limit: rows,
        offset: 0
      });
    }

    const leadStatusApiData = {
      leadTypeIn: [],
      roleIn: [],
      statusIn: [],
      activeOnly: ""
    };



    getLeadStatusApi(leadStatusApiData)
      .then((response) => {
        if (!response.data.error) {
          const newData = response.data.data || response.data; // adjust if API structure differs

          const newLeadStatusData = newData.map(item => ({
            label: item.trim(), value: item.trim()
          }));
          setLeadStatusList(newLeadStatusData);
        } else {
          errorMessage("Invalid Credentials");
        }
      })
      .catch(() => {
        errorMessage();
      })


    getLeadSource()
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          const leadSource = Res.map((item) => ({
            label: item,
            value: item,
          }));


          setLeadSourceList(leadSource)
        } else {
          errorMessage("Invalid Credentials");
        }
      })
      .catch((err) => {
        errorMessage();
      })
      .finally(() => console.log(false));


    const stateCitiesData = {
      searchBy: "",
      searchText: "",
      limit: 100000,
      offset: 0,
      sortBy: "",
      sortOrder: "desc",
      cityIn: [],
      stateIn: []
    }

    getStateWiseCities(stateCitiesData)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;

          // const stateList = Object.keys(Res).map((key) => ({
          //   key
          // }));

          const stateListArray = Object.keys(Res);

          const stateList = stateListArray.map((item) => ({
            label: item,
            value: item,
          }));

          setStateCitiesList(stateList)

          setStateCityList(Res)
        } else {
          errorMessage("Invalid Credentials");
        }
      })
      .catch((err) => {
        errorMessage();
      })
      .finally(() => console.log(false));


    // const typeBranchData = {
    //   searchBy: "",
    //   searchText: "",
    //   limit: 100000,
    //   offset: 0,
    //   sortBy: "",
    //   sortOrder: "desc",
    //   statusIn: []
    // };

    // getBranch(typeBranchData)
    //   .then((response) => {
    //     if (!response.data.error) {
    //       const newData = response.data.data || response.data; // adjust if API structure differs
    //       const branchData = newData.map((item) => ({
    //         label: item.name,
    //         value: item.id,
    //       }));
    //       setBranchDataList(branchData);
    //     } else {
    //       errorMessage("Invalid Credentials");
    //     }
    //   })
    //   .catch(() => {
    //     errorMessage();
    //   })


    const typeProductData = {
      searchBy: "",
      searchText: "",
      limit: 100000,
      offset: 0,
      sortBy: "",
      sortOrder: "desc",
      statusIn: []
    };

    getProduct(typeProductData)
      .then((response) => {
        if (!response.data.error) {
          const newData = response.data.data || response.data; // adjust if API structure differs
          const productData = newData.map((item) => ({
            label: item.name,
            value: item.id,
          }));
          setProductDataList(productData);
        } else {
          errorMessage("Invalid Credentials");
        }
      })
      .catch(() => {
        errorMessage();
      })

  }, []);

  useEffect(() => {

    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    
    let startDate = "";
    let endDate = "";

    if (startDateValue) {
      startDate = new Date(startDateValue);
      endDate = endDateValue ? new Date(endDateValue) : new Date();
    }

    const hasValidFilter =
      recordTypeValue ||
      typeOfLead ||
      startDateValue ||
      endDateValue ||
      leadStatusValue ||
      stateValue ||
      cityValue ||
      // branchDataValue ||
      productDataValue ||
      userDataFilter ||
      leadSourceValue;

    if (!hasValidFilter) return;

    const payload = {
      ...typeData,
      limit: rows,
      offset: 0,
      recordType: recordTypeValue,
      startDate,
      endDate,
      leadTypeIn: typeOfLead ? typeOfLead : [],
      statusIn: leadStatusValue ? leadStatusValue : [],
      sourceIn: leadSourceValue ? leadSourceValue : [],
      // branchIdIn: branchDataValue ? branchDataValue : [],
      productIdIn: productDataValue ? productDataValue : [],
      userIdIn: userDataFilter ? userDataFilter : [],
      addressInfo: { cityIn: cityValue ? cityValue : [], stateIn: stateValue ? [stateValue] : [] }
    };

    fetchData(payload);

  }, [
    recordTypeValue,
    typeOfLead,
    startDateValue,
    endDateValue,
    leadStatusValue,
    leadSourceValue,
    // branchDataValue,
    stateValue,
    cityValue,
    productDataValue,
    userDataFilter
  ]);

  const loadMore = () => {
    const newOffset = first + rows;

    fetchData(
      {
        ...typeData,
        limit: rows,
        offset: newOffset
      },
      true // append mode
    );

    setFirst(newOffset);
  };

  const onFilter = (event) => {
    setFilters(event.filters);

    let searchBy = "";
    let searchText = "";

    // Detect which column filter is applied
    Object.keys(event.filters).forEach((key) => {
      if (key !== "global" && event.filters[key]?.value) {
        searchBy = key;
        searchText = event.filters[key].value;
      }
    });

    fetchData({
      searchBy,
      searchText,
      limit: 20,
      offset: 0,
      sortBy: "",
      sortOrder: "desc",
      statusIn: [],
      sourceIn: [],
    });
  };

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;

    setGlobalFilterValue(value);
    setFirst(0);
    setProducts([]);

    fetchData({
      searchBy: searchByStatus,
      searchText: value,
      limit: 20,
      offset: 0,
      sortBy: "",
      sortOrder: "desc",
      statusIn: []
    });
  };

  const downloadPDF = (data) => {
    if (!data || data.length === 0) return;

    const doc = new jsPDF("landscape");
    const logoImg = new Image();
    logoImg.src = logoBig;

    doc.addImage(logoImg, "PNG", 10, 5, 40, 15);
    doc.setFontSize(16);
    doc.text("CA User Data", 200, 15);

    doc.autoTable({
      head: [["ID", "Date", "Name", "Mobile", "City", "State", "Status"]],
      body: data.map((item) => [
        item.id,
        formatDate(item.createdDate),
        item.name,
        item.mobile,
        item.city,
        item.state,
        item.status ? "ACTIVE" : "INACTIVE"
      ]),
      startY: 25,
      theme: "grid",
      styles: { fontSize: 9 }
    });

    doc.save("CA-User-List.pdf");
  };

  const handleLeadListUpload = (event) => {
    event.preventDefault();
    const fileInput = event.target.querySelector('input[type="file"]');
    const uploadFile = fileInput.files[0];
    const leadSourceUpload = leadSourceUploadValue

    if (!uploadFile) {
      console.error("No file selected");
      return;
    }

    LeadListUpload(uploadFile, leadSourceUpload)
      .then((response) => {
        const Res = response.data;
        // handle the response
        if (Res.status === true) {
          successMessage("Lead List Upload Successfully " + Res.message);
          setFileName("");
          setSelectedImage(null);
          fetchData({
            searchBy: "",
            searchText: "",
            limit: 20,
            offset: 0,
            sortBy: "",
            sortOrder: "desc",
            statusIn: [],
            sourceIn: [],
            // userId: selectedTelecallerId ? [selectedTelecallerId] : allUserDataIds
          });
          setDisplayLeadListUpload(false);
        } else {
          errorMessage("Lead List Upload Failed " + Res.message);
          setFileName("");
          setSelectedImage(null);
          fetchData({
            searchBy: "",
            searchText: "",
            limit: 20,
            offset: 0,
            sortBy: "",
            sortOrder: "desc",
            statusIn: [],
            sourceIn: [],
            // userId: selectedTelecallerId ? [selectedTelecallerId] : allUserDataIds
          });
          setDisplayLeadListUpload(false);
        }
      })
      .catch((error) => {
        // handle errors
        errorMessage("Lead List Upload Failed");
        setFileName("");
        setSelectedImage(null);
        fetchData({
          searchBy: "",
          searchText: "",
          limit: 20,
          offset: 0,
          sortBy: "",
          sortOrder: "desc",
          statusIn: [],
          sourceIn: [],
          // userId: selectedTelecallerId ? [selectedTelecallerId] : allUserDataIds
        });
        setDisplayLeadListUpload(false);
      });
  };

  const handleLeadAssignmentUpload = (event) => {

    event.preventDefault();

    const leadAssignedData = {
      lead: {
        id: assignedLeadId?.lead?.id
      },
      user: {
        id: assignedTelecallerId
      }
    }

    userLeadAssign(leadAssignedData)
      .then((response) => {
        const Res = response.data;
        // handle the response
        if (Res.status === true) {
          successMessage("Lead Assigned Successfully " + Res.message);
          setAssignedTelecallerId("")
          setAssignedLeadId("")
          // fetchData({
          //   searchBy: "",
          //   searchText: "",
          //   limit: 20,
          //   offset: 0,
          //   sortBy: "",
          //   sortOrder: "desc",
          //   statusIn: [],
          //   sourceIn: [],
          //   // userId: selectedTelecallerId ? [selectedTelecallerId] : allUserDataIds
          // });

          setProducts(products);
          setFirst(first);
          setRows(rows);

          setDisplayLeadAssignmentUpload(false);
        } else {
          errorMessage("Lead Assigned Failed " + Res.message);
          setAssignedTelecallerId("")
          setAssignedLeadId("")
          // fetchData({
          //   searchBy: "",
          //   searchText: "",
          //   limit: 20,
          //   offset: 0,
          //   sortBy: "",
          //   sortOrder: "desc",
          //   statusIn: [],
          //   sourceIn: [],
          //   // userId: selectedTelecallerId ? [selectedTelecallerId] : allUserDataIds
          // });

          setProducts(products);
          setFirst(first);
          setRows(rows);

          setDisplayLeadAssignmentUpload(false);
        }
      })
      .catch((error) => {
        // handle errors
        errorMessage("Lead Assigned Failed");
        setAssignedTelecallerId("")
        setAssignedLeadId("")
        // fetchData({
        //   searchBy: "",
        //   searchText: "",
        //   limit: 20,
        //   offset: 0,
        //   sortBy: "",
        //   sortOrder: "desc",
        //   statusIn: [],
        //   sourceIn: [],
        //   // userId: selectedTelecallerId ? [selectedTelecallerId] : allUserDataIds
        // });

        setProducts(products);
        setFirst(first);
        setRows(rows);
        
        setDisplayLeadAssignmentUpload(false);
      });
  };

  const handleLeadListDownload = () => {
    const link = document.createElement("a");
    link.href = "/bulk_Lead_upload.xlsx"; // File path inside public folder
    link.download = "bulk_Lead_upload.xlsx"; // Rename file on download
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleFileChange = (event) => {
    event.preventDefault();
    const file = event.target.files[0];
    setFileName(file ? file.name : ""); // Update the file name or clear it if no file is selected

    const reader = new FileReader();
    reader.onloadend = () => {
      setSelectedImage(reader.result);
    };
    if (file) {
      reader.readAsDataURL(file);
    } else {
      setSelectedImage(null);
    }
  };

  const renderDialogLeadUpload = () => (
    <Dialog
      header="Lead List Upload"
      visible={displayLeadListUpload}
      onHide={() => onHideLeadListUpload()}
      breakpoints={{ "960px": "75vw" }}
      style={{ width: "50vw" }}
    >
      <div>
        <form onSubmit={handleLeadListUpload}>
          <div className="row mb-3">
            <div
              className="col-md-12"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <button
                onClick={handleLeadListDownload}
                style={{
                  padding: "10px",
                  background: "blue",
                  color: "white",
                  border: "none",
                  cursor: "pointer",
                }}
              >
                Download Sample File
              </button>
            </div>
            <div className="col-md-12 mt-3">

              <Dropdown
                style={{ width: "100%" }}
                value={leadSourceUploadValue}
                onChange={(e) => setLeadSourceUploadValue(e.value)}
                options={leadSourceList}
                optionLabel="label"
                placeholder="Select Lead Source"
              />
            </div>
          </div>
          <div className="row mb-3">
            <div
              className="col-md-12"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <div>
                <label for="file-upload" className="custom-file-upload">
                  <i className="pi pi-upload"></i> Choose Lead List File
                </label>
                <input
                  id="file-upload"
                  type="file"
                  onChange={handleFileChange}
                  style={{ display: "none" }}
                />
              </div>
              <div>
                <i
                  className="pi pi-file"
                  style={{ color: "blue", fontSize: "40px" }}
                ></i>
                {fileName && (
                  <p
                    style={{
                      alignSelf: "center",
                      fontSize: 14,
                      fontWeight: 600,
                      margin: 10,
                    }}
                  >
                    {fileName}
                  </p>
                )}
              </div>
            </div>
          </div>
          {selectedImage && (
            <div className="col-md-12 text-center">
              <button
                type="submit"
                className="move-btn move-btn-blue"
              >
                Submit
              </button>
            </div>
          )}
        </form>
      </div>
    </Dialog>
  );

  const renderDialogLeadAssignmentUpload = () => (
    <Dialog
      header="Lead Assignment"
      visible={displayLeadAssignmentUpload}
      onHide={() => onHideLeadAssignmentUpload()}
      breakpoints={{ "960px": "75vw" }}
      style={{ width: "50vw" }}
    >
      <div>
        <form onSubmit={handleLeadAssignmentUpload}>
          <div className="row mb-3">
            <h6> {assignedLeadId?.lead?.name} Lead Assigned To </h6>
            <div
              className="col-md-12"
              style={{ display: "flex", justifyContent: "space-between" }}
            >

              <div className="col-md mb-2">
                <Dropdown
                  style={{ width: "100%" }}
                  options={userDataIds}
                  value={assignedTelecallerId}
                  onChange={(e) => {
                    setAssignedTelecallerId(e.value);
                  }}
                />
              </div>
            </div>
          </div>
          {assignedTelecallerId && (
            <div className="col-md-12 text-center">
              <button
                type="submit"
                className="move-btn move-btn-blue"
              >
                Submit
              </button>
            </div>
          )}
        </form>
      </div>
    </Dialog>
  );

  const itemTemplate = (data) => {
    return (
      <div>
      </div>
    )
  }


  const DeleteLead = () => {

    const leadDeleteData = {
      leadIds: selectedProducts?.map(item => item?.lead?.id),
      statusIn: leadStatusValue
    }

    DeleteLeadData(leadDeleteData)
      .then((response) => {
        const Res = response.data;
        // handle the response
        if (Res.status === true) {
          successMessage("Lead Delete Successfully " + Res.message);
          setAssignedTelecallerId("")
          setAssignedLeadId("")
          fetchData({
            searchBy: "",
            searchText: "",
            limit: 20,
            offset: 0,
            sortBy: "",
            sortOrder: "desc",
            statusIn: [],
            sourceIn: [],
            // userId: selectedTelecallerId ? [selectedTelecallerId] : allUserDataIds
          });
          setDisplayLeadAssignmentUpload(false);
        } else {
          errorMessage("Lead Delete Failed " + Res.message);
          setAssignedTelecallerId("")
          setAssignedLeadId("")
          fetchData({
            searchBy: "",
            searchText: "",
            limit: 20,
            offset: 0,
            sortBy: "",
            sortOrder: "desc",
            statusIn: [],
            sourceIn: [],
          });
        }
      })
      .catch((error) => {
        // handle errors
        errorMessage("Lead Delete Failed");
        setAssignedTelecallerId("")
        setAssignedLeadId("")
        fetchData({
          searchBy: "",
          searchText: "",
          limit: 20,
          offset: 0,
          sortBy: "",
          sortOrder: "desc",
          statusIn: [],
          sourceIn: [],
        });
      });
  }

  return (
    <main id="main" className="main">
      <section className="section main-color">
        <div className="row">
          <div className="col-lg-12">
            <div className="card-main">
              <div className="card-body">


                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                  <div >
                    <h5 className="card-title flex">
                      <div
                        className="mr-3 cursor-pointer"
                        onClick={() => navigate("/")}
                      >
                        <i class="bi bi-arrow-left-circle-fill"></i>
                      </div> Lead List
                    </h5>
                  </div>
                  <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignSelf: "center" }}>
                    <div style={{ alignSelf: "center" }}>
                      {userProfileData.role === "ROLE_OPERATION" ?
                        <Link
                          to="/lead-form-operation-team-create"
                          className="move-btn move-btn-blue center-text"
                        >
                          Create
                        </Link>
                        :
                        <Link
                          to="/lead-form-create"
                          className="move-btn move-btn-blue center-text"
                        >
                          Create
                        </Link>}
                    </div>
                    <div style={{ alignSelf: "center" }}>

                      {userProfileData.role !== "ROLE_TELECALLER" && <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          gap: 20,
                          marginRight: 10,
                          marginLeft: 10,
                        }}
                      >
                        <i
                          onClick={() =>
                            onClickLeadListUpload(
                              "displayLeadListUpload"
                            )
                          }
                          className="pi pi-upload"
                          style={{
                            fontSize: "20px",
                            color: "#1e439b",
                            cursor: "pointer",
                          }}
                        ></i>

                      </div>}
                    </div>
                  </div>
                </div>
                <p className="text-md" style={{ color: "red" }}> * Note: Please User Filters To Find Or Sort Leads Based On Your Requirement</p>
                <p className="text-md" style={{ color: "red" }}> * Note: Please Select Lead Status To Delete Lead</p>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    marginTop: 5,
                    marginBottom: 5,
                  }}
                >
                  <div className="row">
                    <div className="col-md mb-2">
                      <InputText
                        type="text"
                        value={globalFilterValue}
                        onChange={onGlobalFilterChange}
                        placeholder="Keyword Search"
                        style={{ width: "100%" }}
                      />
                    </div>
                    <div className="col-md mb-2">
                      <Dropdown
                        style={{ width: "100%" }}
                        options={searchByStatusData}
                        value={searchByStatus}
                        onChange={(e) => {
                          setSearchByStatus(e.value);
                        }}
                      />
                    </div>

                    <div className="col-md mb-2">
                      <Dropdown
                        style={{ width: "100%" }}
                        options={recordTypeSelection}
                        value={recordTypeValue}
                        placeholder="Select Record Type"
                        onChange={(e) => {
                          setRecordTypeValue(e.value);
                        }}
                      />
                    </div>
                    <div className="col-md mb-2">
                      <MultiSelect
                        style={{ width: "100%" }}
                        value={typeOfLead}
                        onChange={(e) => setTypeOfLead(e.value)}
                        options={leadTypeList}
                        optionLabel="label"
                        placeholder="Select Lead Type"
                      />
                    </div>
                    <div className="col-md mb-2">
                      <Calendar
                        value={startDateValue}
                        onChange={(e) => {
                          const start = e.value;
                          setStartDateValue(start);

                          if (!endDateValue) {
                            setEndDateValue(new Date()); // default today
                          }
                        }}
                        dateFormat="dd/mm/yy"
                        placeholder="Start Date"
                        maxDate={endDateValue ? endDateValue : new Date()}
                        showIcon
                        style={{ width: "100%" }}
                      />
                    </div>
                    <div className="col-md mb-2">
                      <Calendar
                        value={endDateValue}
                        onChange={(e) => setEndDateValue(e.value)}
                        dateFormat="dd/mm/yy"
                        placeholder="End Date"
                        minDate={startDateValue}
                        showIcon
                        style={{ width: "100%" }} />
                    </div>
                  </div>


                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    marginTop: 5,
                    marginBottom: 5,
                  }}
                >
                  <div className="row">

                    <div className="col-md mb-2">
                      <MultiSelect
                        style={{ width: "100%" }}
                        value={leadStatusValue}
                        onChange={(e) => setLeadStatusValue(e.value)}
                        options={leadStatusList}
                        optionLabel="label"
                        placeholder="Select Lead Status"
                      />
                    </div>


                    <div className="col-md mb-2">
                      <MultiSelect
                        style={{ width: "100%" }}
                        value={leadSourceValue}
                        onChange={(e) => setLeadSourceValue(e.value)}
                        options={leadSourceList}
                        optionLabel="label"
                        placeholder="Select Lead Source"
                      />
                    </div>

                    <div className="col-md mb-2">
                      <Dropdown
                        style={{ width: "100%" }}
                        value={stateValue}
                        onChange={(e) => {
                          setStateValue(e.value);
                          setCityValue([])

                        }
                        }
                        options={stateCitiesList}
                        optionLabel="label"
                        placeholder="Select a State"
                        filter
                        filterDelay={400}
                      />
                    </div>

                    <div className="col-md mb-2">
                      <MultiSelect
                        style={{ width: "100%" }}
                        value={cityValue}
                        onChange={(e) => setCityValue(e.value)}
                        options={citiesList}
                        placeholder="Select City"
                      />
                    </div>

                    {/*<div className="col-md mb-2">
                      <MultiSelect
                        style={{ width: "100%" }}
                        value={branchDataValue}
                        onChange={(e) => setBranchDataValue(e.value)}
                        options={branchDataList}
                        optionLabel="label"
                        placeholder="Select Branch"
                      />
                    </div>*/}
                    <div className="col-md mb-2">
                      <MultiSelect
                        style={{ width: "100%" }}
                        value={productDataValue}
                        onChange={(e) => setProductDataValue(e.value)}
                        options={productDataList}
                        optionLabel="label"
                        placeholder="Select Product"
                      />
                    </div>
                    {/*<div className="col-md mb-2">
                      <MultiSelect
                        style={{ width: "100%" }}
                        value={userDataFilter}
                        onChange={(e) => setUserDataFilter(e.value)}
                        options={userDataIds}
                        optionLabel="label"
                        placeholder="Select User"
                      />
                    </div>*/}


                    {selectedProducts?.length > 0 && <div className="col-md mb-2">
                      <button type="button" onClick={() => DeleteLead()} className="move-btn move-btn-blue">
                        Delete
                      </button>
                    </div>}
                  </div>


                </div>
                <div className="dataview-demo">
                  <div className="card">
                    <DataTable
                      value={products}
                      // lazy
                      dataKey="lead.id"
                      scrollable
                      scrollHeight="400px"
                      paginator
                      first={first}   // ✅ THIS FIXES YOUR ISSUE
                      onPage={(e) => setFirst(e.first)} // ✅ also required
                      paginatorTemplate=" FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                      currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                      rows={rows}
                      rowsPerPageOptions={[rows, rows + 50, rows + 100]}
                      loading={loadingMore}
                      className="p-datatable-customers client-table-design"
                      resizableColumns
                      columnResizeMode="fit"
                      filters={filters}
                      onFilter={onFilter}
                      // filterDisplay="row"
                      globalFilterFields={['id', 'createdDate', 'name', "mobile", "city", "state"]}
                      stripedRows
                      selectionMode="multiple" 
                      selection={selectedProducts} 
                      onSelectionChange={(e) => {
                        if (!leadStatusValue) {
                          return; // ❌ block selection
                        }
                        setSelectedProducts(e.value);
                      }}
                    >
                      {leadStatusValue && <Column
                        selectionMode="multiple"
                        header={() => null} 
                        headerStyle={{ width: '3rem' }}
                        className="product-category table-design"
                        body={(rowData) => {
                          return (
                            <input
                              type="checkbox"
                              checked={selectedProducts?.some(p => p.lead.id === rowData.lead.id)}
                              disabled={!leadStatusValue}   // ✅ disable checkbox
                              readOnly
                            />
                          );
                        }}
                      />}
                      <Column
                        header="#"
                        resizeable={false}
                        className="product-category table-design"
                        body={(data, options) => options.rowIndex + 1}
                      ></Column>

                      <Column
                        field="View"
                        header="View"
                        className="product-category table-design"
                        body={(rowData) => (
                          userProfileData.role === "ROLE_OPERATION" ?
                            <Link
                              to="/lead-form-operation-team-create"
                              state={rowData}
                              className="move-btn-medium move-btn-yellow center-text"
                            >
                              View <i className="bi bi-pencil-square"></i>
                            </Link>
                            :
                            <Link
                              to="/lead-form-create"
                              state={{
                                rowData,
                                listState: {
                                  products,
                                  first,
                                  rows
                                }
                              }}
                              className="move-btn-medium move-btn-yellow center-text"
                            >
                              View <i className="bi bi-pencil-square"></i>
                            </Link>

                        )}
                      ></Column>
                      <Column
                        field="assign"
                        header="Assign"
                        className="product-category table-design"
                        body={(rowData) => (

                          <div
                            onClick={() =>
                              onClickLeadAssignmentUpload(
                                rowData
                              )
                            }
                            className="move-btn-medium move-btn-yellow center-text cursor-pointer"
                          >
                            Assign <i className="bi bi-fast-forward-btn-fill"></i>
                          </div>

                        )}
                      ></Column>
                      <Column
                        field="UserInfo"
                        header="User Info"
                        className="product-category table-design"
                        body={(rowData) => (
                          <Link
                            to={"/user-lead-info"}
                            state={{
                              rowData,
                              listState: {
                                products,
                                first,
                                rows
                              }
                            }}
                            className="move-btn-medium move-btn-yellow center-text"
                          >
                            Info <i className="bi bi-fast-forward-btn-fill"></i>
                          </Link>
                        )}
                      ></Column>
                      <Column
                        field="status"
                        header="Status"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {(rowData.lead?.status)}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="dateOfLead"
                        header="Date Of Lead"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {formatDateWithTime(rowData.lead?.dateOfLead)}
                          </span>
                        )}
                      ></Column>

                      <Column
                        field="name"
                        header="Name"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData?.lead?.name}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="mobileNo"
                        header="Mobile No"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData.lead?.mobileNo}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="typeOfLead"
                        header="Type Of Lead"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData?.lead?.typeOfLead ? replaceUnderscoresWithSpacesAndUpperCase(rowData?.lead?.typeOfLead) : ""}

                          </span>
                        )}
                      ></Column>

                      <Column
                        field="amount"
                        header="Amount (In Lacs)"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData.lead?.amount}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="preferredLanguage"
                        header="Preferred Language"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData.lead?.preferredLanguage}
                          </span>
                        )}
                      ></Column>

                      <Column
                        field="sales"
                        header="Sales"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData?.leadInfoList
                              ?.find((item) => item.keyName === "sales")
                              ?.textValue || ""}
                          </span>
                        )}
                      ></Column>

                      <Column
                        field="whatIsYourCibilScore"
                        header="Cibil Score"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData?.leadInfoList
                              ?.find((item) => item.keyName === "whatIsYourCibilScore")
                              ?.textValue || ""}
                          </span>
                        )}
                      ></Column>


                      <Column
                        field="queries"
                        header="Remarks"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData.lead?.queries}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="queries"
                        header="Remarks"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData?.leadInfoList
                              ?.find((item) => item.keyName === "remarkByTelecaller")
                              ?.textValue || ""}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="address"
                        header="Address"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData.lead?.address}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="source"
                        header="Source"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData.lead?.source}
                          </span>
                        )}
                      ></Column>

                      <Column
                        field="followUpOn"
                        header="Follow Up On"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData.lead?.followUpOn}
                          </span>
                        )}
                      ></Column>

                     

                      

                      {(userProfileData.role === "ROLE_TELECALLER" || userProfileData.role === "ROLE_SUPER_TELECALLER") &&
                        <Column
                          field="Doc"
                          header="Doc View"
                          className="product-category table-design"
                          body={(rowData) => (
                            <Link
                              to={"/view-lead-document"}
                              state={rowData?.lead}
                              className="move-btn-medium move-btn-green center-text"
                            >
                              Doc View <i className="bi bi-eye"></i>
                            </Link>
                          )}
                        ></Column>}

                    </DataTable>
                  </div>
                  <DataScroller
                    ref={ds}
                    value={products}
                    itemTemplate={itemTemplate}
                    rows={5}
                    loader
                  // footer={footer} 
                  // header="Click Load Button at Footer to Load More" 
                  />
                  <div
                    className="flex justify-content-center fixed "
                    style={{ bottom: 30, left: 20 }}
                  >
                    <Button
                      type="text"
                      icon="pi pi-plus"
                      // label="More"
                      onClick={loadMore} // Update this to trigger `getData`
                    />
                  </div>
                  {/*products && products.length < totalRecords && (
                    <div style={{ textAlign: "center", margin: "20px" }}>
                      <button
                        onClick={loadMore}
                        disabled={loadingMore}
                        style={{
                          padding: "10px 20px",
                          backgroundColor: "#1e439b",
                          color: "#fff",
                          border: "none",
                          cursor: "pointer",
                          borderRadius: "5px"
                        }}
                      >
                        {loadingMore ? "Loading..." : "Load More"}
                      </button>
                    </div>
                  )*/}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div>{renderDialogLeadUpload()}</div>
      <div>{renderDialogLeadAssignmentUpload()}</div>
    </main>
  );
}
